<template>
  <div class="homepage">
    <!-- <Head />
    <TSwiper /> -->
    <div class="content1 fx">
        <div class="content_left wow animate__fadeInLeft">
            <div class="left_text1">信息化原创性</div>
            <div  class="left_text2">技术软件研发企业</div>
            <div class="left_text1">数智展览展示</div>
            <div  class="left_text2">一站式解决方案综合服务商</div>
            
            <div class=" left_text3 pt03 fx ls1 pb_004 tc cursor">
              <div class="text2">信息化技术软件开发</div>  
              <div class="shu">|</div>
              <div class="text1">VR&AR</div>
              <div class="shu">|</div>
              <div class="text1">人工智能</div>
              <div class="shu">|</div>
              <div class="text1">大数据</div>
            </div>
            <div class=" left_text3 ls1 fx tc cursor">
              <div class="text1">党建展厅</div>
              <div class="shu">|</div>
              <div class="text1">企业展厅</div>
              <div class="shu">|</div>
              <div class="text1">文化展厅</div>
              <div class="shu">|</div>
              <div class="text1">招商展厅</div>
              <div class="shu">|</div>
              <div class="text1">工业展厅</div>
              <div class="shu">|</div>
              <div class="text1">城市展厅</div>
            </div>
            <img src="@/assets/computer/shouye/xRight.png" class="left_img pt03 cursor">
        </div>
        <div class="content_right wow animate__fadeInRight">
            <img src="@/assets/computer/shouye/buxy4nzl.jpg" v-if=" ifimgshow" class="img1">
            <img src="@/assets/computer/shouye/bf.png" v-if=" ifimgshow" @click="bofang" class="img_icon">
            <div id="dplayer" class="dplayer video-box"></div>
        </div>
    </div>
    <div class="title1 pb012 wow animate__zoomIn">
        <div class="fw_3 color4 fs_03">
            DIGITALMULTImEDIA
        </div>
        <div class="fw_6 color4 fs_01"> 数字</div>
        <div class="fw_6 color4 fs_01"> 多媒体</div>
    </div>
    <!-- 数字多媒体 -->
    <div class="content2 fx">
        <div :class="item.type==2?'typeimg':'itemimg'" v-for="(item,index) in content3list" @mouseenter="mouseenter(index)" @mouseleave="mouseleave(index)">
            <img v-if="item.type==1" :src="item.img1" class="content2_img1">
            <img v-if="item.type==2" :src="item.img2" class="content2_img2">
            <div v-if="item.type==1" class="yinyin"></div>
            <div class="c_content" v-if="item.type==1">
                <img :src="item.img0" class="iconimg pb01">
                <div class="color5 fs_01 fw_8 pb_004">  {{ item.text1 }}  </div>
                <div class="color5 fs_065 fw_3 pb_002">  {{ item.text2 }}  </div>
                <div class="color5 fs_065 fw_3 pb012">  {{ item.text3 }}  </div>
                <img src="@/assets/computer/shouye/xRight2.png" class="iconimg1">
            </div>
            <div class="c_content b" v-if="item.type==2" @click="listitem(index)">
                <img :src="item.img0" class="iconimg2 pt03 pb01">
                <div class="color5 fs_01 fw_8 pb_004">  {{ item.text1 }}  </div>
                <div class="color5 fs_065 fw_3 pb_002">  {{ item.text2 }} </div>
                <div class="color5 fs_065 fw_3 pb012">  {{ item.text3 }}  </div>
                <div :class="typeindex == index1 ?'b_item cursor fs_0075 color5 witeback' : 'b_item cursor fs_0075 color5' " v-for="(item1,index1) in item.list" 
                    @mouseenter="tmous(index1)"
                    @mouseleave="tleave(index1)"

                > {{ item1 }} </div>
            </div>
        </div>
    </div>
    <div class="title2 pt04 wow animate__zoomIn">
        <div class="fw_3 color4 fs_03">
            CASE SHARING
        </div>
        <div class="fw_6 color4 fs_01"> 案例</div>
        <div class="fw_6 color4 fs_01"> 分享</div>
    </div>
    <!-- 案例分享 -->
    <div class="content3 fx f_j_ce">
        <div class="content3_left wow animate__flipInX" >
            <div class="content_text tc">
                <div class="fs_01 fw_2 ls2 pb_008">数智展览展示</div>
                <div class="fs_065 fx f_a_c f_j_ce cursor">
                    <div class="fw_2  pr002">了解更多</div>
                    <img src="@/assets/computer/shouye/xRight1.png" class="content3_icon">
                </div>
            </div>
            <div class="content_yy"></div>
            <img src="@/assets/computer/shouye/anli1.png" class="content3_img" >
        </div>
        <div class="content3_right wow animate__flipInX" >
            <div class="content_text tc">
                <div class="fs_01 fw_2 ls2 pb_008">软件开发</div>
                <div class="fs_065 fx f_a_c f_j_ce cursor">
                    <div class="fw_2  pr002">了解更多</div>
                    <img src="@/assets/computer/shouye/xRight1.png" class="content3_icon">
                </div>
            </div>
            <div class="content_yy"></div>
            <img src="@/assets/computer/shouye/anli2.png" class="content3_img">
        </div>
    </div>
    <div class="content4 mt06 color5">
        <img src="@/assets/computer/shouye/mengban.jpg" style="width:100%;height:100%">
        <div class="c_text">
            <div class="pb_002 fs_0075 fw_3">信息化原创性技术软件研发企业</div>
            <div class="fs_0075 fw_3">数智展览展示一站式解决方案综合服务商</div>
            <div class="fx pt02">
                <div>
                    <div class="fs_025 fw_6">
                        <countTo
                        :startVal="startVal1" 
                        :endVal="endVal1" 
                        :duration="1000" 
                        :autoplay="true"
                        id="counts1"
                        ></countTo>
                        <span class="fs_0075">项</span>
                    </div>
                    <div class="fs_007">发明专利</div>
                </div>
                <div class="xuxian"></div>
                <div >
                    <div class="fs_025 fw_6">
                        <countTo
                        :startVal="startVal2" 
                        :endVal="endVal2" 
                        :duration="1000" 
                        :autoplay="true"
                        id="counts2"
                        ></countTo>
                        <span class="fs_0075">项</span>
                    </div>
                    <div class="pb_002 fs_007">软件著作权等核心</div>
                    <div class="fs_007">自主知识产权</div>
                </div>
                <div class="xuxian"></div>
                <div>
                    <div class="fs_025 fw_6" style="position: relative;">
                        <countTo
                        :startVal="startVal3" 
                        :endVal="endVal3" 
                        :duration="1000" 
                        :autoplay="true"
                        id="counts2"
                        ></countTo>
                        <span class="jiahao fs_0075">＋</span>
                    </div>
                    <div class="pb_002 fs_007">服务客户</div>
                    <div class="fs_007">10余年行业经验</div>
                </div>
            </div>
        </div>
    </div>
    <!-- 新闻中心标题5 -->
    <div class="title5 fx f_j_sb fa_fe">
        <div>
            <div class="fw_3 color4 fs_03">
                NEWS CENTER
            </div>
            <div class="fw_6 color4 fs_01"> 新闻</div>
            <div class="fw_6 color4 fs_01"> 中心</div>
        </div>
        <div class="fx">
            <img v-if="xwzxL" src="@/assets/computer/shouye/xinwenL1.png" class="title5_img" @mouseenter="xwzxLj()" >
            <img v-else src="@/assets/computer/shouye/xinwenL2.png" class="title5_img" @mouseleave="xwzxLc()">
            <img v-if="xwzxR" src="@/assets/computer/shouye/xinwenR1.png" class="title5_img" @mouseenter="xwzxRj()">
            <img v-else src="@/assets/computer/shouye/xinwenR2.png" class="title5_img" @mouseleave="xwzxRc()">
        </div>
    </div>

    <div v-for="item in reslist" class="fs_03">{{ item.title }}tt</div>
    <!-- 新闻中心 -->
    <div class="content5 fx">
        <div class="content5_item cursor" @click="xwClick(0)">
            <img :src="reslist0.imgPath" class="content5_img1 mb01" >
            <div class="fx f_j_sb f_a_c pb012">
                <div class="content5_time">
                    <div class="fs_015 fw_5">{{reslist0.date_m}}</div>
                    <div class="fs_007">{{reslist0.date_y}}</div>
                </div>
                <div> <img src="@/assets/computer/shouye/xRight3.png" style="width: 0.15rem ;height:auto;"></div>
            </div>
            <div class="fw_6 fs_0075 pb_006"> {{reslist0.title}}</div>
            <div class=" fs_0075 lh011"> {{reslist0.sumys}}</div>
        </div>
        <div class="content5_item fx fx_flow_j f_j_sb">
            <div class="fx cursor " @click="xwClick(1)">
                <img :src="reslist1.imgPath" class="content5_leftimg">
                <div class="">
                    <div class="l_left fx fx_flow_j f_j_sb">
                        <img src="@/assets/computer/shouye/xRight3.png" class="l_left_img">
                        <div class="l_left_text">
                            <div>
                                <div class="fs_015 fw_5">{{reslist1.date_m}}</div>
                                <div class="fs_007">{{reslist1.date_y}}</div>
                            </div>
                            <div>
                                <div class="fw_6 fs_01 pb_004">{{reslist1.title}}</div>
                                <div class="fs_0075 lh011">{{reslist1.sumys}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fx cursor p5" @click="xwClick(2)">
                <img :src="reslist2.imgPath" class="content5_leftimg">
                <div class="">
                    <div class="l_left fx fx_flow_j f_j_sb">
                        <img src="@/assets/computer/shouye/xRight3.png" class="l_left_img">
                        <div class="l_left_text">
                            <div>
                                <div class="fs_015 fw_5">{{reslist2.date_m}}</div>
                                <div class="fs_007">{{reslist2.date_y}}</div>
                            </div>
                            <div>
                                <div class="fw_6 fs_01 pb_004">{{reslist2.title}}</div>
                                <div class="fs_0075 lh011">{{reslist2.sumys}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fx cursor" @click="xwClick(3)">
                <img :src="reslist3.imgPath" class="content5_leftimg">
                <div class="">
                    <div class="l_left fx fx_flow_j f_j_sb">
                        <img src="@/assets/computer/shouye/xRight3.png" class="l_left_img">
                        <div class="l_left_text">
                            <div>
                                <div class="fs_015 fw_5">{{reslist3.date_m}}</div>
                                <div class="fs_007">{{reslist3.date_y}}</div>
                            </div>
                            <div>
                                <div class="fw_6 fs_01 pb_004">{{reslist3.title}}</div>
                                <div class="fs_0075 lh011">{{reslist3.sumys}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
    <div>
        <TSwiper1 :arrList="arrList" :type="type"/>
    </div>

    <div class="head_text fx ">
        <div class="ht_left fx f_j_sb wow animate__zoomIn">
            <div class="" v-for="item in head_list">
                <div class="ht_title color5 fs_0092 pb01">{{item.title}}</div>
                <div class="fx fx_flow_j color8 ">
                    <div class="pb_003 cursor fs_007" v-for="item1 in item.list">{{ item1 }}</div>
                </div>
            </div>
            <div class="shuxian"></div>
        </div>
        <div class="ht_right color8 wow animate__zoomIn">
            <img src="@/assets/computer/shouye/ewm.png" class="pb01" style="width: 0.4rem;height:0.4rem;">
            <div class="fs_007 pb_003">联系电话：0791-83800662</div>
            <div class="fs_007 pb_003">地址：南昌市红谷滩新区九龙湖新城VR产业基地1号楼10楼</div>
            <div class="fs_007 pb_003">网址：www.c-hone.com</div>
            <div class="fs_007">邮箱：tuyucong@163.com</div>
        </div>
    </div>
    <div class="bottom_text fs_0092"> 南昌世弘泛亚科技股份有限公司  备案号：00000000号 Copyright 2024版权所有</div>
    
  </div>
</template>

<script setup>
 import Head from '@/components/computer/head.vue'
 import TSwiper1 from '@/components/computer/Tswiper1.vue'
 import { useRouter } from 'vue-router'
 import {ref, nextTick, onMounted, reactive } from "vue";
 import { Swiper } from 'swiper/vue';
 const router = useRouter()
 const reslist0 = ref('')
 const reslist1 = ref('')
 const reslist2 = ref('')
 const reslist3 = ref('')
 
 let data = []
 datalist(data).then(r=>{ //获取村庄列表
     reslist0.value =r.data.data[0]
     reslist1.value =r.data.data[1]
     reslist2.value =r.data.data[2]
     reslist3.value =r.data.data[3]
 })
 const xwClick = (e)=>{
     router.push({path:'/Journalism',query:{index:e}})
 }
 const xwzxL = ref(true)
 const  xwzxLj = ()=>{
    xwzxL.value = !xwzxL.value
 }
 const  xwzxLc = ()=>{
    xwzxL.value = !xwzxL.value
 }
 const xwzxR = ref(true)
 const  xwzxRj = ()=>{
    xwzxR.value = !xwzxR.value
 }
 const  xwzxRc = ()=>{
    xwzxR.value = !xwzxR.value
 }
 const scaleimg1 = ref(false)
 const scaleimg2 = ref(false)
 const scaleimgj = (e)=>{
    if (e==1) {
        scaleimg1.value=!scaleimg1.value   
    }else{
        scaleimg2.value=!scaleimg2.value
    }
 }
 const scaleimgc = (e)=>{
    if (e==1) {
        scaleimg1.value=!scaleimg1.value
    }else{
        scaleimg2.value=!scaleimg2.value
    }
    
 }
 const type = ref(2)
 const arrList = ref([
    {
        text:'COOPERATION PARTNER',
        text1:'合作',
        text2:'伙伴',
        img1:require('@/assets/computer/shouye/z153.png'),
    },{
        text:'COOPERATION PARTNER',
        text1:'合作',
        text2:'伙伴',
        img1:require('@/assets/computer/shouye/z154.png'),
    },{
        text:'COOPERATION PARTNER',
        text1:'合作',
        text2:'伙伴',
        img1:require('@/assets/computer/shouye/z155.png'),
    },
 ])
 const head_list=ref([
    {
        title:'关于我们',
        list:['公司介绍','文化理念','核心优势','发展历程','公司荣誉',]
    },{
        title:'主营事业',
        list:['数字多媒体+智慧展厅事业部','信息化技术软件开发事业部',]
    },{
        title:'案例分析',
        list:['数智慧展览展示','软件开发',]
    },{
        title:'新闻资讯',
        list:['公司新闻','行业动态',]
    },{
        title:'联系我们',
        list:['联系方式',]
    },
 ])
 const listitem = (e)=>{
    router.push({path:'/mainbusiness',query:{index1:0,index2:1,index3:e}})
 }

 import {datalist} from '@/untils/api'
import { CountTo } from 'vue3-count-to'
const startVal1 = ref(0)
const endVal1 = ref(1)
const startVal2 = ref(0)
const endVal2 = ref(1)
const startVal3 = ref(0)
const endVal3 = ref(1)
const content3list = ref([
    {
        type :2,
        img0:require('@/assets/computer/shouye/cjkj0.png'),
        img1:require('@/assets/computer/shouye/cjkj1.jpg'),
        img2:require('@/assets/computer/shouye/cjkj2.jpg'),
        text1:'沉浸空间',
        text2:'IMMERSION',
        text3:'SPACE',
        list:['裸眼3D大屏幕','异形创意屏幕','CAVE沉浸空间','穹幕沉浸影院','弧幕/环幕影院','飞行影院','3DMapping',]
    },{
        type :1,
        img0:require('@/assets/computer/shouye/cycp0.png'),
        img1:require('@/assets/computer/shouye/cycp1.jpg'),
        img2:require('@/assets/computer/shouye/cycp2.jpg'),
        text1:'数智元宇宙',
        text2:'MATHEMATICAL INTELLIGENCE',
        text3:'METAVERSE',
        list:['虚拟数字人','展馆中控','XR虚拟拍摄','元宇宙展厅','数字沙盘','数字孪生/数据可视化','全息幻象沙盘','裸眼3D沙盘',]
    },{
        type :1,
        img0:require('@/assets/computer/shouye/hdty0.png'),
        img1:require('@/assets/computer/shouye/hdty1.jpg'),
        img2:require('@/assets/computer/shouye/hdty2.jpg'),
        text1:'全息屏幕',
        text2:'HOLOGRAPHIC',
        text3:'SCREEN',
        list:['全息幻像','OLED全息屏','全息投影屏','全息透明屏','幻影成像','全息隐形屏',]
    },{
        type :1,
        img0:require('@/assets/computer/shouye/qxpm0.png'),
        img1:require('@/assets/computer/shouye/qxpm1.jpg'),
        img2:require('@/assets/computer/shouye/qxpm2.jpg'),
        text1:'互动投影',
        text2:'INTERACTIVE',
        text3:'PROJECTION',
        list:['体感互动','地面互动投影','沉浸交互空间','墙面互动投影','虚拟迎宾员','虚拟涂鸦','虚拟翻书',]
    },{
        type :1,
        img0:require('@/assets/computer/shouye/sznr0.png'),
        img1:require('@/assets/computer/shouye/sznr1.jpg'),
        img2:require('@/assets/computer/shouye/sznr2.jpg'),
        text1:'创意触屏',
        text2:'CREATIVE TOUCH',
        text3:'SCREEN',
        list:['滑轨屏','电子签名留言','多屏联动（时间轴）','物体识别桌','知识抢答','触摸交互大屏','飞屏互动',]
    },{
        type :1,
        img0:require('@/assets/computer/shouye/szyyz0.png'),
        img1:require('@/assets/computer/shouye/szyyz1.jpg'),
        img2:require('@/assets/computer/shouye/szyyz2.jpg'),
        text1:'数字内容',
        text2:'DIGITAL',
        text3:'CONTENT',
        list:['3D数字影片','动画制作','宣传片','VR内容制作','互动程序/游戏','触摸屏软件','全息幻象沙盘','裸眼3D沙盘',]
    },
])
const mouseenter = (e)=>{
    let list = []
    content3list.value.forEach((item,index) =>{
        if (e==index) {
            item.type = 2
        }else{
            item.type = 1
        }
        list.push(item)
    })
    content3list.value = list
}
const mouseleave = (e)=>{
    // content3list.value[e].type = 1
}
const typeindex =ref()
const tmous = (e) =>{
    typeindex.value = e
}
const tleave = (e) => {
    // typeindex.value = ''
}
// 视频播放
// import Hls from 'hls.js'  //用于播放hlv格式
// import Flv from 'flv.js'  //用于播放m3u8格式
import DPlayer from 'dplayer'
const loadVideo=()=>{
   const dp = new DPlayer({
        container: document.getElementById('dplayer'), //播放器容器元素
        autoplay: false, //是否自动播放
        live: false, //是否直播
        theme: '#b7daff', //主题色 底部进度条相关颜色
        loop: true, //是否循环播放
        lang: 'zh-cn', //语言
        screenshot: true, //开启截图，如果开启，视频和视频封面需要允许跨域
        hotkey: true, //开启热键，支持快进、快退、音量控制、播放暂停
        preload: 'auto', //视频预加载，可选值: 'none', 'metadata', 'auto'
        volume: 0, //初始化音量
        playbackSpeed: [0.5, 1, 2, 4, 8], //播放速度
        mutex: false, //互斥，阻止多个播放器同时播放，当前播放器播放时暂停其他播放器
        preventClickToggle: false, //阻止点击播放器时候自动切换播放/暂停
        // logo: 'logo.png', //在左上角展示一个 logo，你可以通过 CSS 调整它的大小和位置
        video: {
          pic: require('@/assets/computer/shouye/buxy4nzl.jpg'), // 视频封面
          url: require('@/assets/computer/shouye/video1.mp4'), //视频链接
          thumbnails:'',//视频缩略图，可以使用 DPlayer-thumbnails生成
          type: 'auto', //可选值: 'auto', 'hls', 'flv', 'dash', 'webtorrent', 'normal' 或其他自定义类型,
          customType: {
            //自定义播放类型文件《type需要设置为'customHls'》
            customHls: function (video, player) {
              const hls = new Hls()
              hls.loadSource(video.src)
              hls.attachMedia(video)
            },
            //自定义播放类型文件《type需要设置为'customFlv'》
            customFlv: function (video, player) {
              const flvPlayer = Flv.createPlayer({
                type: 'flv',
                url: video.src,
              })
              flvPlayer.attachMediaElement(video)
              flvPlayer.load()
            },
          },
        },
      })
      //考虑隐私问题，初始化时把音量设为0,才可自动播放
      //dp.volume(percentage: number, nostorage: boolean, nonotice: boolean): 设置视频音量
      dp.volume(0, true, true) 
      //视频组件加载完成后自动播放
      dp.on('loadedmetadata', function () {
        dp.play()
      })
      //视频流出问题时触发
      dp.on('error', function () {
        if (document.getElementById('player')) {
          //当前时间＋1
          let time = Number(Math.round(dp.video.currentTime + 1))
          //重新加载视频
          loadVideo()
          //跳转到更新后的时间
          dp.seek(time)
        }
      })
}
const ifimgshow = ref(true)
const bofang = ()=>{
    ifimgshow.value = false
    loadVideo()
}
onMounted(() => {
    endVal1.value = 6
    endVal2.value = 32
    endVal3.value = 500
});

// 页面滚动触发方法
//   var scrollTopValue = document.documentElement.scrollTop || document.body.scrollTop;
  window.onscroll = function () { 
    var scrollTopValue = document.documentElement.scrollTop || document.body.scrollTop;             

    if ( 2500 <= scrollTopValue && scrollTopValue <=2550 ) {

        endVal1.value = 5
        endVal2.value = 31
        endVal3.value = 499
        setTimeout(() => {
            endVal1.value = 6
            endVal2.value = 32
            endVal3.value = 500
        }, 100);
    }
  }
  var lastScrollTop = 0;
  window.addEventListener("scroll", function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > lastScrollTop) {
        //   console.log('向下滚动')
      } else {
        //   console.log('向上滚动')
      }
      lastScrollTop = scrollTop;
  });

</script>

<style scoped>
/* 内容1 */
    .content1{
        width: 100%;
    }
    .content_left{
        width: 33%;
        /* height: 3rem; */
        position: relative;
        padding: 0.5rem 0 0 17%;
    }
    .content_right{
        width: 50%;
        height: 2.785rem;
        position: relative;
    }
    .left_img{
        width: 0.22rem;
        height: auto;
    }
    .text1{
        width: 0.36rem;
    }
    .text2{
        width: 0.79rem;
    }
    .left_text1{
        font-size: 0.09rem;
        color: #696969;
        padding: 0 0 0.03rem;
        font-weight: 500;
    }
    .left_text2{
        font-size: 0.15rem;
        color: #000;
        font-weight: 800;
        padding: 0 0 0.1rem;
    }
    .left_text3{
        font-size: 0.07rem;
    }
    .img1{
        width: 100%;
        height: auto;
        z-index: 2;
        position: absolute;
    }
    .img_icon{
        width: 0.3rem;
        height:  0.3rem;
        position: absolute;
        top: 48%;
        left: 48%;
        z-index: 2;
    }
    .dplayer{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 1;
    }
    .shu{
        padding: 0 0.02rem;
    }
    .title1{
        padding: 0.4rem 0  0.25rem 17%;
    }
    .title2{
        width: 100%;
        text-align: center;
    }
/* 内容2 */
    .content2{
        width: 100%;
        height: 3.91rem;
    }
    .c_content{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        text-align: center;
        display: flex;
        flex-flow: column;
        align-items: center;
    }
    .b{
    background-color: rgba(189, 8, 10, 0.9);
    }
    .b_item{
        width: 30%;
        padding: 0.05rem 0;
        border: 0.5px solid #f87e81;
        margin-bottom: 0.05rem;
        border-radius: 1rem;
    }
    .iconimg{
        width: 0.45rem;
        height: 0.45rem;
        margin-top: 2.3rem;
    }
    .iconimg2{
        width: 0.45rem;
        height: 0.45rem;
    }
    .iconimg1{
        width: 0.12rem;
        height: auto;
    }
    .witeback{
        background-color: #fff;color: #000;
    }
    .itemimg{
        width: 12.5%;
        height: 100%;
        position: relative;
    }
    .typeimg{
        width: 37.5%;
        height: 100%;
        position: relative;
    }
    .yinyin{
        width: 100%;
        height: 100%;
        background-image: linear-gradient(to bottom, rgba(255,255,255,0.1), rgba(0,0,0,1));
        position: absolute;
        top: 0;
        left: 0;
    }
    .content2_img1{
        width: 100%;
        height: 100%;
    }
    .content2_img2{
        width: 100%;
        height: 100%;
    }
/* 内容3 */
    .content3{
        margin-top: 0.2rem;
    }
    .content3_left{
        width: 31.5%;
        height: auto;
        overflow: hidden;
        margin-right: 2%;
        position: relative;
    }
    
    .content3_right{
        width: 31.5%;
        height: auto;
        overflow: hidden;
        position: relative;
    }
    .content_text{
        width: 100%;
        position: absolute;
        top: 0.18rem;
        left: 0;
        z-index: 3;
        color: #fff;
    }
    .content_yy{
        width: 100%;
        height: 50%;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(to bottom, #000000, rgba(0,0,0,0));
        opacity: 0.8;
        z-index: 2;
    }
    .content3_img{
        width: 100%;
        height: auto;
        /* 设置放大比例 */
        transform: scale(1);
        /* 给图片添加过渡效果 */
        transition: all 1s;
    }
    .content3_img:hover{
        transform: scale(1.2);
    }
    .content3_icon{
        width: 0.08rem;
        height: auto;
    }
/* 内容4 */
    .content4{
        width: 100%;
        height: auto;
        position: relative;
    }
    .c_text{
        position: absolute;
        top: 0.3rem;
        left: 17%;
    }
    .jiahao{
        position: absolute;
        top: 0;
        right: -0.08rem;
    }
    .xuxian{
        height: 0.3rem;
        border-left: 1px dashed #ccc;
        margin: 0.08rem 0.2rem;
    }
/* 内容5 */
.l_left_text{
    width: 80%;
    height: 100%;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
}
    .title5{
        width: 66%;
        padding: 0.4rem 17%  0.25rem 17%;
    }
    .title5_img{
        width: 0.13rem;
        height: 0.15rem;
        margin-bottom: 0.1rem;
    }
    .content5{
        width: 70%;
        padding: 0 0  0.6rem  0;
        margin: 0 auto;
    }
    .content5_item{
        width: 46%;
        padding:0 2%;
    }
    .content5_img1{
        width: 100%;
        height: auto;
    }
    .l_left{
        padding:  0 0 0 0.18rem;
        position: relative;
        height: 100%;
    }
    .l_left_img{
        width: 0.15rem;
        height: auto;
        position: absolute;
        right: 0;
        top: 40%;
    }
    .p5{
        padding: 0.1rem 0;
    }
    .content5_leftimg{
        width: 30%;
        height: 0.7rem;
    }
    /* 底部导航 */
    .head_text{
        width: 70%;
        padding: 0.3rem 15%;
        background-color: #333333;
    }
    .shuxian{
        border-left: 1px dashed #4e4e4e;
        padding: 0 0.2rem;
    }
    .ht_left{
        width: 70%;
    }
    .ht_right{
        width: 30%;
    }
    .bottom_text{
        width: 100%;
        padding: 0.1rem 0;
        text-align: center;
        background: red;
        color: #fff;
    }

</style>
